import { TimePickerOption, TimeRangeKey, TimeRangeLabel } from '../../components/time-picker/types';
import { FixedTimeRange, MovingWindowTimeRange } from '../../models/time-range';

export const TIMEPICKER_OPTIONS: TimePickerOption[] = [
  {
    timeRange: new MovingWindowTimeRange(TimeRangeKey.LAST_1H),
    label: TimeRangeLabel.LAST_1H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.LAST_12H),
    label: TimeRangeLabel.LAST_12H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.LAST_1DAY),
    label: TimeRangeLabel.LAST_DAY
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.LAST_1WEEK),
    label: TimeRangeLabel.LAST_WEEK
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.MINUS_24H),
    label: TimeRangeLabel.MINUS_24H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.PLUS_24H),
    label: TimeRangeLabel.PLUS_24H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.CUSTOM),
    label: TimeRangeLabel.CUSTOM
  }
];

export const TIMEPICKER_FUSION_OPTIONS: TimePickerOption[] = [
  {
    timeRange: new MovingWindowTimeRange(TimeRangeKey.LAST_1H),
    label: TimeRangeLabel.LAST_1H
  },
  {
    timeRange: new MovingWindowTimeRange(TimeRangeKey.LAST_1H_CACHED),
    label: TimeRangeLabel.LAST_1H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.LAST_12H),
    label: TimeRangeLabel.LAST_12H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.LAST_1DAY),
    label: TimeRangeLabel.LAST_DAY
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.LAST_1WEEK),
    label: TimeRangeLabel.LAST_WEEK
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.MINUS_24H),
    label: TimeRangeLabel.MINUS_24H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.PLUS_24H),
    label: TimeRangeLabel.PLUS_24H
  },
  {
    timeRange: new FixedTimeRange(TimeRangeKey.CUSTOM),
    label: TimeRangeLabel.CUSTOM
  }
];

export const DEFAULT_TIMEPICKER_OPTION = TIMEPICKER_OPTIONS[0];
